<template>
  <nav-bar title="我的" />
  <Content :bottom="0">
    <div class="user-info">
      <span>{{ $store.state.userInfo.nickName }}</span>
      <span>-</span>
      <span>{{ $store.state.roleInfo.roleName }}</span>
    </div>
    <!-- <van-cell title="个人信息维护" is-link /> -->
    <van-cell title="修改密码" is-link to="/resetPassword" />
    <van-cell title="通知信息" is-link to="/notificationInformation" />
    <van-cell
      v-if="
        $store.state.roleInfo.roleId === '6' ||
        $store.state.roleInfo.roleId === '1'
      "
      title="督办信息"
      :value="num === '0' ? '' : num"
      is-link
      to="/supervisionInformation"
    />
    <van-cell
      v-if="
        $store.state.roleInfo.roleId === '6' ||
        $store.state.roleInfo.roleId === 'c'
      "
      title="检查历史"
      is-link
      to="/checkHistory"
    />
    <van-cell
      v-if="$store.state.roleInfo.roleId === 'c'"
      title="报警器管理"
      is-link
      to="/alarmManagement"
    />
    <van-cell title="系统帮助" is-link to="/help" />
    <van-cell
      v-if="$store.state.roleInfo.roleName === '销售人员'"
      title="重新关联二维码"
      to="/reassociateCode?method=getCylinderListByDept"
      is-link
    />
  </Content>
</template>

<script>
import { getNoReadNum } from '@/api/user'
import { useGetData } from '@/hooks/useGetData'
import { useStore } from 'vuex'
import { computed, ref } from 'vue'
export default {
  name: 'My',
  setup() {
    const store = useStore()
    const username = computed(() => store.state.userInfo.username)
    const companyId = computed(() => store.state.roleInfo.companyId)
    const roleId = computed(() => store.state.roleInfo.roleId)
    const num = ref('0')
    useGetData(getNoReadNum, (data) => {
      num.value = data
    })({
      username: username.value,
      companyId: companyId.value,
      roleId: roleId.value
    })
    return { num }
  }
}
</script>

<style lang="scss" scoped>
.user-info {
  padding: 10px 16px;
  font-size: 14px;
  background-color: #fff;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
  margin-bottom: 16px;
  span:first-child {
    color: #333;
    font-weight: 600;
  }
  span:last-child {
    color: #1989fa;
  }
  span:nth-child(2) {
    padding: 0 10px;
  }
}
</style>
